const imageCache = new Map<string, Promise<HTMLImageElement>>();

export function loadCanvasImage(url: string): Promise<HTMLImageElement> {
  const cached = imageCache.get(url);
  if (cached) return cached;

  const promise = new Promise<HTMLImageElement>((resolve, reject) => {
    const image = new Image();
    image.decoding = "async";
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error(`Failed to load image: ${url}`));
    image.src = url;
  });

  imageCache.set(url, promise);
  return promise;
}

export function parsePercent(value: string | undefined, fallback: number): number {
  if (!value) return fallback;
  const numeric = Number.parseFloat(value);
  if (!Number.isFinite(numeric)) return fallback;
  return value.trim().endsWith("%") ? numeric / 100 : numeric;
}
